const setEmptyValuesToNull = (value) => {
  if (value === "" || value === undefined) return null;
};

export default setEmptyValuesToNull;
